const maps = require('../modules/maps');
const locations = require('../modules/locations');

maps.init();
locations.init();
